import { render, staticRenderFns } from "./V2ProfilePreviewCollections.vue?vue&type=template&id=3509c776&scoped=true&"
import script from "./V2ProfilePreviewCollections.vue?vue&type=script&lang=js&"
export * from "./V2ProfilePreviewCollections.vue?vue&type=script&lang=js&"
import style0 from "./V2ProfilePreviewCollections.vue?vue&type=style&index=0&id=3509c776&lang=scss&scoped=true&"
import style1 from "./V2ProfilePreviewCollections.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3509c776",
  null
  
)

export default component.exports